import React, { useState } from 'react';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Box from '@mui/material/Box';
import TabContext from '@mui/lab/TabContext';
import TabPanel from '@mui/lab/TabPanel';
import { SiteTitle } from '../SiteTitle';
import { loginInfo } from "../globalFunction/global_string";
import CreateTenableList from './CreateTenableList';
import ViewTenableTrackingList from './ViewTenableTrackingList';

function Tenable_Track_Background() {
    const [value, setValue] = useState('1');

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <div>
            <SiteTitle />
            <TabContext value={value}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs
                        value={value}
                        onChange={handleChange}
                        aria-label="tracking tabs"
                        TabIndicatorProps={{
                            style: {
                                backgroundColor: "blue",
                            }
                        }}
                    >
                        <Tab label="建立主機清單" value="1" />
                        <Tab label="查看主機清單" value="2" />
                    </Tabs>
                </Box>
                <TabPanel value="1">
                    <CreateTenableList />
                </TabPanel>
                <TabPanel value="2">
                    <ViewTenableTrackingList />
                </TabPanel>

            </TabContext>
        </div>
    );
}

export default Tenable_Track_Background;
